/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var EmptyServerIcon = createIcon("EmptyServerIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return /*#__PURE__*/React.createElement("svg", {
    width: "120",
    height: "120",
    viewBox: "0 0 120 120",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M60 120c33.137 0 60-26.863 60-60S93.137 0 60 0 0 26.863 0 60s26.863 60 60 60Z",
    fill: "#CFCEFD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".35",
    d: "M32 45.006c0-1.108.899-2.006 1.992-2.006h41.016c1.1 0 1.992.897 1.992 2.006v9.988A2.003 2.003 0 0175.008 57H33.992c-1.1 0-1.992-.897-1.992-2.006v-9.988Zm0 16c0-1.108.899-2.006 1.992-2.006h41.016c1.1 0 1.992.897 1.992 2.006v9.988A2.003 2.003 0 0175.008 73H33.992c-1.1 0-1.992-.897-1.992-2.006v-9.988Zm0 16c0-1.108.899-2.006 1.992-2.006h41.016c1.1 0 1.992.897 1.992 2.006v9.988A2.003 2.003 0 0175.008 89H33.992c-1.1 0-1.992-.897-1.992-2.006v-9.988Z",
    fill: "#A5AEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 39.006c0-1.108.899-2.006 1.992-2.006h41.016c1.1 0 1.992.897 1.992 2.006v9.988A2.003 2.003 0 0181.008 51H39.992c-1.1 0-1.992-.897-1.992-2.006v-9.988Z",
    fill: "#0C0D0D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 48.005c0 .55.447.995.993.995h39.014a1 1 0 00.993-.995v-8.01a.996.996 0 00-.993-.995H40.993a1 1 0 00-.993.995v8.01Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 43.5h-8a.5.5 0 000 1h8a.5.5 0 000-1Z",
    fill: "#0C0D0D",
    stroke: "#665AF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 55.006c0-1.108.899-2.006 1.992-2.006h41.016c1.1 0 1.992.897 1.992 2.006v9.988A2.003 2.003 0 0181.008 67H39.992c-1.1 0-1.992-.897-1.992-2.006v-9.988Z",
    fill: "#0C0D0D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 64.005c0 .55.447.995.993.995h39.014a1 1 0 00.993-.995v-8.01a.996.996 0 00-.993-.995H40.993a1 1 0 00-.993.995v8.01Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 59.5h-8a.5.5 0 000 1h8a.5.5 0 000-1Z",
    fill: "#0C0D0D",
    stroke: "#665AF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 71.006c0-1.108.899-2.006 1.992-2.006h41.016c1.1 0 1.992.897 1.992 2.006v9.988A2.003 2.003 0 0181.008 83H39.992c-1.1 0-1.992-.897-1.992-2.006v-9.988Z",
    fill: "#0C0D0D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 80.005c0 .55.447.995.993.995h39.014a1 1 0 00.993-.995v-8.01a.996.996 0 00-.993-.995H40.993a1 1 0 00-.993.995v8.01Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 75.5h-8a.5.5 0 000 1h8a.5.5 0 000-1Z",
    fill: "#0C0D0D",
    stroke: "#665AF4"
  }));
}, {
  "i18nKey": "svg.EmptyServerIcon"
});